import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="What is inside the ebook" className="bg-transparent" data-id="element-192" data-mp="1845bcd7ch719">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-193" data-mp="1822asz8kfvia">
        <div className="text-center" data-id="element-194" data-mp="1zujhtod13h2w">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-195" data-mp="1zvktnv1vc7lo">
            🧩 THE AUTONOMOUS CHILD VISUAL SYSTEM™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-196" data-mp="1qud5i5t2gn5b">
            What Will You Find Inside?
          </h2>
          <p className="mt-2 text-base text-plum/60" data-id="element-197" data-mp="1vs4zd5d9ujc5">
            6 routine volumes · 50 print-ready pages — morning, afternoon and night in one place.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-198" data-mp="ke13ftn4il4g">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" data-id="element-199" data-mp="3o86p4jvt86ca">
                {p}
              </span>)}
          </div>
          <p className="mt-8 font-display text-lg font-black uppercase tracking-[0.18em] text-plum-soft" data-id="element-200" data-mp="21huad87nlk9">
            📚 The 6 Routine Volumes
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-201" data-mp="3t9m7g46lryqz">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group rounded-2xl border border-grape/15 bg-white p-5 transition-colors duration-200 ease-out hover:border-grape/45" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-202" data-mp="azaadjlrax8p" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-203" data-mp="wv26oy1imapu">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-204" data-mp="11su0jxlq06wo">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-205" data-mp="1bivkqeayd56b">
                  <span aria-hidden="true" data-id="element-206" data-mp="1fkh5smxn4prl">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-207" data-mp="1kiacri6rpnsx">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-208" data-mp="1piy464yws6no">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-209" data-mp="1ug6l628bm4nc">
            ✅ Key features — simple to use, flexible to adapt
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-210" data-mp="3gnraiqudb7">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-211" data-mp="2ddhw4whk0137">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-212" data-mp="2dfkt60h4iuhf" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-blush/30 bg-blush-soft p-6 text-center" style={{
        paddingTop: "5px",
        paddingBottom: "6px"
      }} data-id="element-213" data-mp="24ly2upvoqjfm">
          <p className="font-display text-lg font-black text-blush-deep" data-id="element-214" data-mp="2wcvudqmbfxzi">
            No other subscription
          </p>
          <p className="mt-2 text-sm text-plum/70" style={{
          fontWeight: "600"
        }} data-id="element-215" data-mp="2scbyeqdhb0ey">
            <span className="block" data-id="element-216" data-mp="2nb4n4hc4nj3j">❌ Therapy Session: $150/hour</span>
            <span className="block" data-id="element-217" data-mp="2id37659zzzwa">❌ Subscription Apps: $120/year</span>
            <span className="block font-bold text-plum" data-id="element-218" data-mp="2iexgembwq3kj">✅ Sigma Smart System: <span className="text-blush" data-id="element-219" data-mp="1bxk4g90opl3j">$19</span></span>
            <span className="block font-bold text-plum" data-id="element-220" data-mp="16xxqtygy22u7">✅ One-time payment forever</span> 
          </p>
          <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-plum/80" data-id="element-221" data-mp="2uum229hpq4nf">
            {['No monthly subscription', 'No ads', 'No files to install', 'Mobile-friendly'].map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-222" data-mp="2lu7fl6t0ijic">
                <CheckIcon className="h-4 w-4 shrink-0 text-blush" strokeWidth={3} data-id="element-223" data-mp="2lrurebwnvcwu" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}